import { Component } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';

import { ErrorPageLayoutComponent } from '@core/components/error-page-layout/error-page-layout.component';

@Component({
  selector: 'app-no-dataspace',
  imports: [TranslatePipe, ErrorPageLayoutComponent],
  templateUrl: './no-dataspace.component.html'
})
export class NoDataspaceComponent {}
